// state
const state = {
    items: [],
    itemsAccounting: [],
  }
  
  // mutations
  const mutations = {
    SET_ITEM_PURCHASE (state, data) {
      let obj = {
        id: data.id,
        fecha: data.date,
        'Cont.': data.accounting,
        número: data.number,
        'razón social': data.business_name,
        nit: data.nit,
        total: data.total,
      }
      const flag = state.items.some(item => item.id === obj.id)
      if (!flag) state.items.push(obj)

      let objAccounting = {
        id: data.id,
        fecha: data.date,
        'Cont.': data.accounting,
        total: data.total,
        'Cuenta Debe': data.cta_debe,
        'Cuenta Haber': data.cta_haber,
      }
      const flagAccounting = state.itemsAccounting.some(item => item.id === objAccounting.id)
      if (!flagAccounting) {
        if(objAccounting['Cont.'] == 'NO') {
          state.itemsAccounting.push(objAccounting)
        }       
      } 
    },
    
    DELETE_ITEM_PURCHASE (state, id) {
      state.items.splice(id, 1)
      state.itemsAccounting.splice(id, 1)
    },
  
    EMPTY_PURCHASE (state) {
      state.items = []
      state.itemsAccounting = []
    },
  }
  
  // actions
  const actions = {
    setItemPurchase({ commit }, data) {
      commit('SET_ITEM_PURCHASE', data)
    },
  
    deleteItemPurchase({ commit }, id) {
      commit('DELETE_ITEM_PURCHASE', id)
    },
  
    emptyPurchase({ commit }) {
      commit('EMPTY_PURCHASE')
    },
  }
  
  // getters
  const getters = {
    itemsPurchase: state => {
      return state.items
    },

    itemsPurchaseAccounting: state => {
      return state.itemsAccounting
    }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }